var ChannelMemberList = require('channelmemberlist');
var Child = require('child');
var Member = require('member');
var Topic = require('topic');
var util = require('../lib/util.es6');
var twitch = require('../lib/twitch.es6');


var Channel = Child.extend({
    initialize: function (data, options) {
        options.channel = this;
        this.members = new ChannelMemberList([], options);
        Child.prototype.initialize.apply(this, arguments);
        this.setUserMember(this.user);
        this.timestamp = null;
        this.channelUrl = null;
        this.modeParams = {};
        this.modeString = '';
    },
    idName: function () {
        return this.connection.channelSlug(this.getName());
    },
    idNamespace: function () {
        return 'channel';
    },
    getType: function () {
        if (this.isSlackMultiPersonDm()) {
            return 'direct message';
        } else {
            return 'channel';
        }
    },
    isChannel: function() {
        return true;
    },
    getTimestamp: function () {
        if (this.timestamp > 0) {
            return new Date(this.timestamp);
        }
    },
    checkFocusOnMakeBufferName: function (focusOnMakeBuffer) {
        var parts = this.getSafeChanParts();
        if (parts) {
            if (focusOnMakeBuffer === parts.prefix + parts.name) {
                return true;
            }
            if (focusOnMakeBuffer === parts.prefix + parts.prefix + parts.name) {
                return true;
            }
        }
        return focusOnMakeBuffer === this.getName().toLowerCase();
    },
    isSlackMultiPersonDm: function () {
        return this.connection.isSlack() && !!this.getSlackMultiPersonParts();
    },
    getTwitchInfo: function () {
        return this.connection.getTwitchChannelInfo(this);
    },
    getTwitchRoomParts: function () {
        if (!this.isTwitchRoom()) {
            return;
        }
        var parts = this.normalise().split(':');
        var foundRoom, foundInfo, foundChannel;
        if (this.connection.twitchChannelInfo) {
            _.find(this.connection.twitchChannelInfo, function (info, channel) {
                if (info.rooms && info.channel._id == parts[1]) {
                    _.find(info.rooms, function (room) {
                        if (room._id == parts[2]) {
                            foundRoom = room;
                            foundInfo = info;
                            foundChannel = channel;
                            return true;
                        }
                        return false;
                    });
                }
                return false;
            });
            if (foundInfo && foundRoom) {
                return [foundRoom, foundInfo, foundChannel];
            }
        }
    },
    getTwitchRoomNameParts: function () {
        var parts = this.getTwitchRoomParts();
        if (parts) {
            return [parts[1].channel.display_name, parts[0].name];
        }
    },
    getTwitchDisplayName: function (twitchInfo) {
        twitchInfo = twitchInfo || this.getTwitchInfo();
        if (twitchInfo && twitchInfo.channel.display_name) {
            return twitchInfo.channel.display_name;
        }
    },
    getDisplayName: function () {
        var safeChanParts = this.getSafeChanParts();
        if (safeChanParts) {
            return safeChanParts.prefix + safeChanParts.name;
        } else if (this.connection.isSlack()) {
            var mpdm = this.getSlackMultiPersonNicks();
            if (mpdm) {
                return _.map(this.getSlackMultiPersonNicks(), function (nick) {
                    var u = this.connection.findUser(nick);
                    return u ? u.getDisplayName() : nick;
                }, this).join(', ');
            }
        } else if (this.connection.isTwitch()) {
            if (this.isTwitchRoom()) {
                var twitchRoomNameParts = this.getTwitchRoomNameParts();
                if (twitchRoomNameParts) {
                    return twitchRoomNameParts.join(' : ');
                }
            } else {
                var twitchName = this.getTwitchDisplayName();
                if (twitchName) {
                    return twitchName;
                }
            }
        }
        return this.getName();
    },
    getSlackMultiPersonParts: function () {
        return this.getName().match(/^#mpdm-(.*)-\d$/);
    },
    getSlackMultiPersonNicks: function () {
        var parts = this.getSlackMultiPersonParts();
        if (parts) {
            var nicks = _.filter(parts[1].split('--'), _.bind(function (nick) {
                return nick != this.connection.getNick();
            }, this));
            if (nicks.length) {
                nicks.sort(util.naturalCompare);
                return nicks;
            }
        }
    },
    isTwitchRoom: function () {
        return this.connection.isTwitch() &&
            this.normalise().indexOf('chatrooms:') === 0;
    },
    isTwitchRestrictedRoom: function () {
        if (this.isTwitchRoom()) {
            var twitchRoomParts = this.getTwitchRoomParts();
            if (twitchRoomParts) {
                var roomInfo = twitchRoomParts[0];
                return roomInfo.minimum_allowed_role &&
                    roomInfo.minimum_allowed_role != 'EVERYONE';
            }
        }
        return false;
    },
    hasTwitchRooms: function (twitchInfo) {
        twitchInfo = twitchInfo || this.getTwitchInfo();
        if (twitchInfo && twitchInfo.rooms && twitchInfo.rooms.length) {
            return true;
        } else {
            return false;
        }
    },
    safeChanSuffix: function () {
        var idParts = this.getSafeChanParts();
        if (idParts) {
            return '(' + idParts.id + ')';
        }
    },
    getSafeChanParts: function () {
        var idchan = this.connection.getISupport('IDCHAN');
        if (idchan) {
            var name = this.getName();
            var prefix = name[0];
            if (prefix in idchan) {
                var idLength = idchan[prefix];
                var id = name.slice(1, idLength + 1);
                var chanName = name.slice(idLength + 1);
                return {
                    prefix: prefix,
                    id: id,
                    name: chanName
                };
            }
        }
    },
    getUrl: function () {
        if (this.connection.isSlack()) {
            return this.getSlackUrl();
        }
        return this.channelUrl;
    },
    getSlackUrl: function () {
        return this.connection.getSlackBaseUrl() + 'messages/' + this.normalise() + '/details/';
    },
    setTimestamp: function (timestamp) {
        this.timestamp = timestamp;
        this.trigger('timestampChange', this);
    },
    setUrl: function (url) {
        this.channelUrl = url;
        this.trigger('urlChange', this);
    },
    init: function (message) {
        this.trigger('preinit');
        this.chan_members_failed = message.chan_members_failed;

        this.resetMembers(message.members);
        // Propagate to existing conversations
        this.getMembers().each(function (member, i) {
            var conversation = member.findConversation();
            if (conversation) {
                conversation.setRecipientProps(member.attributes);
            }
        }, this);
        
        if (message.timestamp > 0) {
            this.setTimestamp(message.timestamp * 1000);
        }
        
        var topic = message.topic;
        if (topic) {
            var author;
            if (topic.nick) {
                author = this.connection.makeUserFromTarget(
                    this.id,
                    _.extend({}, topic, {
                        hostmask: topic.usermask,
                        from_name: topic.user,
                        from_host: topic.userhost
                    })
                );
            }
            this.setTopic(topic.text, author, topic.time, topic.server);
        }
        
        this.setMode(message.ops);

        this.setUrl(message.url);

        if (this.connection.isInitialized() && this.connection.isTwitch()) {
            this.connection.setupTwitch();
            this.connection.throttledTwitchPoll();
        }
        
        this.activate();
        
        this.trigger('init', this);
        
        return this;
    },
    messageHandlers: $.extend({}, Child.prototype.messageHandlers, {
        rename_channel: function (message) {
            var newName = message.new_name;
            this.set({name: newName});
            if (this.isSelected()) {
                this.connection.urlChange();
            }
        },
        channel_init: function (message) {
            this.init(message);
        },
        member_updates: function (message) {
            _.each(message.updates, function (details, nick) {
                var member = this.getMember(nick);
                // We can be sent this event when not joined to the channel,
                // so the member list would be empty
                if (member) {
                    // Don't override an away message we might already have
                    var memberAway = member.getAway();
                    if (memberAway && details.away) {
                        details.away = memberAway;
                    }
                    member.set(details);
                }
                // Propagate to existing conversation
                var conversation = this.connection.findConversation(nick);
                if (conversation) {
                    conversation.setRecipientProps(details);
                }
            }, this);
        }
    }),
    initializedMessageHandlers: $.extend({}, Child.prototype.initializedMessageHandlers, {
        channel_topic: function (message) {
            var author;
            var server = message.get('server');
            if (!server) {
                author = this.connection.makeUserFromTarget(
                    this.id,
                    _.extend({}, message.attributes, {
                        nick: message.get('author')
                    })
                );
            }
            this.setTopic(message.get('topic'), author, message.get('topic_time'), server);
        },
        channel_timestamp: function (message) {
            this.setTimestamp(message.get('timestamp') * 1000);
        },
        channel_url: function (message) {
            this.setUrl(message.get('url'));
        },
        channel_mode_is: function (message) {
            this.setMode(message.get('ops'));
        },
        channel_mode: function (message) {
            this.setMode(message.get('ops'));
        },
        user_channel_mode: function (message) {
            var member = this.getMember(message.get('nick'));
            if (member) {
                member.setMode(message.get('newmode'));
            }
        },
        user_chghost: function (message) {
            var member = this.getMember(message.get('nick'));
            if (member) {
                member.set({
                    user: message.from_name,
                    userhost: message.from_host,
                    usermask: message.hostmask
                });
            }
        },
        joined_channel: function (message) {
            var params = {};
            _.each({
                'cid': 'cid',
                'bid': 'bid',
                'nick': 'nick',
                'hostmask': 'usermask',
                'ident_prefix': 'ident_prefix',
                'from_name': 'user',
                'from_host': 'userhost',
                'realname': 'realname',
                'from_realname': 'realname',
                'account': 'account',
                'from_account': 'account',
                'avatar': 'avatar',
                'avatar_url': 'avatar_url',
                'display_name': 'display_name',
                'status_text': 'status_text',
                'pronouns': 'pronouns',
                'bot_url': 'bot_url'
            }, function (uprop, mprop) {
                if (message.has(mprop)) {
                    params[uprop] = message.get(mprop);
                }
            });
            this.addMember(params);
        },
        parted_channel: function (message) {
            this.removeMember(message.get('nick'));
        },
        quit: function (message) {
            this.removeMember(message.get('nick'));
        },
        kicked_channel: function (message) {
            this.removeMember(message.get('nick'));
        },
        you_parted_channel: function (message) {
            this.deactivate();
        },
        you_kicked_channel: function (message) {
            this.deactivate();
        },
        nickchange: function (message) {
            this.updateMemberNick(message);
        },
        you_nickchange: function (message) {
            this.updateMemberNick(message);
        }
    }),
    addMember: function (data) {
        var member = this.getMember(data.nick);
        if (!member) {
            this.members.add(this.createMember(data));
        } else {
            debug.warn('Duplicate member joined_channel: ' + data.nick, data, member);
        }
    },
    removeMember: function (nick) {
        var member = this.getMember(nick);
        if (member) {
            this.members.remove(member);
        } else {
            debug.warn('Removing a missing member: ' + nick);
        }
    },
    updateMemberNick: function (message) {
        var member = this.getMember(message.get('oldnick'));
        // This is sent for us even when not in channel
        if (member) {
            member.set({nick: message.get('newnick')});
        }
    },
    getPrefKey: function (key) {
        return 'channel-' + key;
    },
    prefKeys: $.extend({}, Child.prototype.prefKeys, {
        'hiddenMembers': ['showMembers', true],
        'notifications-all': ['notifications-all-disable', false]
    }),
    setShowMembersPref: function (enable) {
        this.setOverridePref(enable, 'hiddenMembers');
    },
    setNotifyAllPref: function (enable) {
        this.setOverridePref(enable, 'notifications-all');
    },
    shouldShowMemberList: function () {
        return this.checkPref('hiddenMembers');
    },
    shouldNotifyAll: function () {
        return this.checkPref('notifications-all');
    },
    // Ignore global setting for mpdms
    isTrackingUnread: function () {
        if (this.isSlackMultiPersonDm()) {
            return !this.getPref('disableTrackUnread');
        } else {
            return this.checkPref('disableTrackUnread');
        }
    },
    setTrackingUnreadPref: function (enable) {
        if (this.isSlackMultiPersonDm()) {
            this.setPref('disableTrackUnread', !enable);
        } else {
            this.setOverridePref(enable, 'disableTrackUnread');
        }
    },
    createMember: function (data) {
        return new Member(data, {
            session: this.session,
            connection: this.connection,
            channel: this
        });
    },
    resetMembers: function (members) {
        var nicks = [];
        // Filter dupes, this should never happen but does
        var memberList = _.filter(_.map(members, function (member, i) {
            if (_.include(nicks, member.nick)) {
                debug.warn('Duplicate member in channel_init: ' + member.nick, _.find(members, function (m) {
                    return m.nick == member.nick;
                }), member);
            } else {
                nicks.push(member.nick);
                var newMember = this.createMember({
                    cid: this.getCid(),
                    bid: this.bid(),
                    nick: member.nick,
                    realname: member.realname,
                    account: member.account,
                    mode: member.mode,
                    ircserver: member.ircserver,
                    away: member.away,
                    user: member.user,
                    usermask: member.usermask,
                    userhost: member.userhost,
                    ident_prefix: member.ident_prefix,
                    avatar: member.avatar,
                    avatar_url: member.avatar_url,
                    display_name: member.display_name,
                    status_text: member.status_text,
                    pronouns: member.pronouns,
                    bot_url: member.bot_url
                });
                if (this.session.isInitialized()) {
                    var existingMember = this.getMember(member.nick);
                    if (existingMember) {
                        newMember.setLastSpoke(existingMember.getLastSpoke());
                        newMember.setLastHighlighted(existingMember.getLastHighlighted());
                    }
                }
                return newMember;
            }
        }, this), _.identity);
        this.members.reset(memberList);
        // Not guaranteed to be in the member list, IRCds and ZNC etc can do strange things
        this.setUserMember(this.getMember(this.connection.getNick()));
    },
    getUser: function () {
        return this.userMember || Child.prototype.getUser.call(this);
    },
    clearTopic: function () {
        this.topic = null;
        this.trigger('topicChange', this);
    },
    isMod: function () {
        return this.userMember.isMod();
    },
    canSetTopic: function () {
        var topicControl = !!this.hasMode('t');
        return this.isActive() && (!topicControl || this.isMod());
    },
    setTopic: function (topic, author, time, server) {
        if (time > 0) {
            time = time * 1000;
        } else {
            time = null;
        }
        this.topic = new Topic({
            author: author,
            topic: topic,
            time: time,
            server: server
        });
        this.trigger('topicChange', this);
    },
    setMode: function (ops) {
        if (!ops) {
            return;
        }
        _.each(ops.remove, function (remove, i) {
            delete this.modeParams[remove.mode];
        }, this);
        _.each(ops.add, function (add, i) {
            this.modeParams[add.mode] = add.param;
        }, this);
        
        this.previousModeString = this.modeString;
        this.modeString = '';
        var values = [];
        for (var k in this.modeParams) {
            if (this.modeParams[k]) {
                values.push(this.modeParams[k]);
            }
            this.modeString += k;
        }
        if (values.length) {
            this.modeString += ' ' + values.join(' ');
        }
        if (this.previousModeString != this.modeString) {
            this.trigger('modeChange', this);
        }
    },
    clearMode: function () {
        this.modeString = '';
        this.previousModeString = '';
        this.modeParams = {};
        this.trigger('modeChange', this);
    },
    hasMode: function (mode) {
        return mode in this.modeParams;
    },
    getMode: function (mode) {
        return this.modeParams[mode];
    },
    isPassworded: function () {
        return this.hasMode('k');
    },
    isSecret: function () {
        return this.hasMode('s');
    },
    getKey: function () {
        return this.getMode('k');
    },
    getTopic: function () {
        return this.topic;
    },
    connectionStateChange: function () {
        if (this.connection.isDisconnected() && !this.connection.wasDisconnected()) {
            this.deactivate();
        }
    },
    setUserMember: function (user) {
        if (user) {
            if (!this.userMember) {
                this.userMember = new Member(user.attributes, {
                    session: user.connection,
                    connection: this.connection,
                    buffer: this,
                    channel: this
                });
            } else {
                this.userMember.set(user.attributes);
            }
            this.stopListening(null, 'change', this.setUserMember);
            this.listenTo(user, 'change', this.setUserMember);
        }
    },
    rename: function (newName, callback) {
        this.post('rename-channel', {
            name: newName
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('renameError', newName, response, callback);
            }
            if (callback) {
                callback(response);
            }
        }, this));
    },
    deactivate: function () {
        Child.prototype.deactivate.call(this);
        this.members.reset();
        this.setUserMember(this.user);
        this.clearMode();
        this.setTimestamp(null);
        this.setUrl(null);
        this.clearTopic();
    },
    
    // Actions
    join: function () {
        this.connectionPost('join', {
            channel: this.getName(),
            key: this.getKey()
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
        }, this));
    },
    part: function (message) {
        this.connectionPost('part', {
            channel: this.getName(),
            msg: message
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
        }, this));
    },
    op: function (user) {
        // TODO make this a web service so we don't need to construct the call
        this.connectionSay("/op " + user.getName());
    },
    deop: function (user) {
        // TODO make this a web service so we don't need to construct the call
        this.connectionSay("/deop " + user.getName());
    },
    voice: function (user) {
        // TODO make this a web service so we don't need to construct the call
        this.connectionSay("/voice " + user.getName());
    },
    devoice: function (user) {
        // TODO make this a web service so we don't need to construct the call
        this.connectionSay("/devoice " + user.getName());
    },
    kick: function (user, reason) {
        // TODO make this a web service so we don't need to construct the call
        this.connectionSay("/kick " + user.getName() + " " + reason);
    },
    ban: function (mask) {
        this.connection.channelBan(this.getName(), mask);
    },
    banList: function () {
        this.connection.channelBanList(this.getName());
    },
    updateTopic: function (topic) {
        this.connectionPost('topic', {
            channel: this.getName(),
            topic: topic
        }, _.bind(function (response) {
            if (!response.success) {
                this.trigger('postError', response);
            }
        }, this));
    }
});


module.exports = Channel;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/channel.js
// module id = KU+H
// module chunks = 1